import React from 'react'
import block from 'bem-cn-lite'
import { statuses, tooltipTexts, users } from './data'

import InfoTooltip from '../Components/InfoTooltip'
import ReportChart from './ReportChart'
import ReportStatuses from './ReportStatuses'
import createCustomEvent from '../createCustomEvent'
import { I18n } from 'react-i18next';

const b = block('Report');

class Report extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            statuses: statuses,
            inactiveStatuses: [],
            isEmptyOut: false,
            step: 'deselectOne'
        }

        this.onStatusClick = this.onStatusClick.bind(this);
    }

    onStatusClick(id) {
        let state = {}
        let resultArray = [];
        let index = this.state.inactiveStatuses.indexOf(id);

        if(index > -1) {
            resultArray = this.state.inactiveStatuses.filter(sid => sid !== id);
        } else {
            resultArray = this.state.inactiveStatuses.concat([id]);
        }

        state.inactiveStatuses = resultArray;
        state.isEmptyOut = this.isNothingToShow(users, state.inactiveStatuses )

        switch(this.state.step) {
            case 'deselectOne':
                state.step = 'deselectOneMore';
                break;
            case 'deselectOneMore':
                if(resultArray.length > 0) {
                    state.step = 'selectOne';
                } else {
                    state.step = 'deselectOne';
                }
                break;
            case 'selectOne':
                if(resultArray.length < this.state.inactiveStatuses.length) {
                    state.step = 'selectOneMore';
                }
                break;
            case 'selectOneMore':
                if(resultArray.length < this.state.inactiveStatuses.length) {
                    state.step = 'final';
                }
                break;
            default: break;
        }

        this.setState(state);

        let status = this.state.statuses.find(status => status.id === id)
        let enabled = this.state.inactiveStatuses.indexOf(id) > -1
        window.dispatchEvent(createCustomEvent('IS_REPORT__STATUS_STATE_CHANGED', { detail: { status: status.name, enabled: enabled } }))
    }

    isNothingToShow(users, excludedStatuses) {
        
        var showCount = 0;

        users.forEach(user => {
            showCount += user.tasks.reduce((prev, curr) => {
                if(prev.status && excludedStatuses.indexOf(prev.status) > -1) {
                    prev = { count: 0 }
                }

                if(excludedStatuses.indexOf(curr.status) > -1) {
                    return prev
                } else {
                    return { count: prev.count + curr.count };
                }
            }).count;
        })

        return showCount === 0;
    }

    render() {
        return (
            <I18n ns={ ['report'] }>
            {
                (t) => (
                    <div className={b()}>
                        <InfoTooltip text={tooltipTexts[this.state.step]} />
                        <div className={b('header')}>
                            <h3 className={b('title')}>{t('report:title')}</h3>
                        </div>
        
                        <div className={b('content')}>
                            <ReportStatuses
                                statuses={this.state.statuses}
                                inactiveStatuses={this.state.inactiveStatuses}
                                onStatusClick={this.onStatusClick}
                                step={this.state.step}
                            />
                            <ReportChart inactiveStatuses={this.state.inactiveStatuses} isEmptyOut={this.state.isEmptyOut} />
                        </div>
                    </div>
                )
            }
            </I18n>

        )
    }

}

export default Report;